import styled, { useTheme } from "styled-components";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import { observer, inject } from "mobx-react";
import { DropDownMenu, Text } from "../UI";
import CoralisLogo from "../assets/img/coralislogo.svg";
import lobbyImg from "../assets/img/lobby.svg";
import lobbyBoldImg from "../assets/img/lobbyBold.svg";
import docsImg from "../assets/img/docs.svg";
import docsBoldImg from "../assets/img/docsBold.svg";
import notificationImg from "../assets/img/notification.svg";
import notificationBoldImg from "../assets/img/notificationBold.svg";
import accountImg from "../assets/img/account.svg";
import accountBoldImg from "../assets/img/accountBold.svg";
import appliesBoldImg from "../assets/img/appliesBold.svg";
import appliesImg from "../assets/img/applies.svg";
import contactsImg from "../assets/img/contacts.svg";
import addSquareImg from "../assets/img/add-square.svg";
import contactsBoldImg from "../assets/img/contactsBold.svg";
import buildingBoldImg from "../assets/img/buildingBold.svg";
import buildingImg from "../assets/img/building-4.svg";
import buildingRegImg from "../assets/img/building.svg";
import logoutImg from "../assets/img/logout.svg";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingContainer from "../layouts/LoadingContainer";
import { useMobile } from "../utils/mobile";
import { useEffect, useState } from "react";
import closeMsgImg from "../assets/img/close-circle.svg";
import { subscribe } from "../utils/events";
import { Role } from "../stores/userStore";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";
import { CircleDiv } from "../components/Common";
import { MenuItem } from "../components/MobileMenuItem";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ open, isMobile }) => ({
    flexGrow: 1,
    // paddingInlineStart: !isMobile && (!open ? 0 : drawerWidth),
  })
);

const DrawerHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
}));

const Line = styled("hr")(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.color.gray50}`
}));
const MobileDrawer = ({
  children,
  userStore,
  isLoading,
  tenantsStore,
  departments,
  ...props
}) => {
  const theme = useTheme();
  let location = useLocation().pathname;
  const { t, i18n } = useTranslation("common");
  const navigate = useNavigate();
  const isMobile = useMobile();
  const [open, setOpen] = useState(false);
  const [showDepratmentsMenu, setShowDepratmentsMenu] = useState(false);
  const [menuKey, setMenuKey] = useState(0);

  useEffect(() => {
    subscribe("showDrawer", () => setOpen(true));
    document.body.style.zoom = "1";
    window.scrollTo(0, 0);
    return () => {
    };
  }, []);

  const handlelLogout = () => {
    const route =
      userStore.userDetails?.role === Role.Tenant
        ? `/tenants/login`
        : `admin/login`;
    userStore.logout();
    tenantsStore.setContracts([]);
    signOut(auth);
    navigate(route);
  };

  const handleSelectProjectChange = async (value) => {

    const siteData = {
      MAINCUST: value.CUST,
      MAINENV: value?.MDNAME || value?.BDNAME,
    }

    await tenantsStore.getCustomerData(siteData);
    const project = tenantsStore.sites?.find(
      (s) => s.SITE === value?.SITE
    );
    const data = {
      ...value,
      SITE: project?.SITE,
      SITEID: project?.SITEID,
      DNAME: value?.MDNAME || value?.BDNAME,
    };
    await tenantsStore.setSelectedContract(null);
    if (
      data.SPACENAME !== tenantsStore.selectedSiteSpace?.SPACENAME ||
      data.CUST !== tenantsStore.selectedSiteSpace?.CUST
    )
      await tenantsStore.setSelectedSiteSpace(data);
    await tenantsStore.setSelectedTheme(project?.THEME);
    setMenuKey(prev => prev + 1); // Force remount of child

    if (
      tenantsStore.selectedSiteSpace?.ISONLYBEDEK === "Y" ||
      tenantsStore.selectedSiteSpace?.BEDEK === "Y" ||
      project?.BEDEK === "Y"
    ) {
      navigate("/bedek/applies");
    } else {
      navigate("/tenant/lobby");
    }
    setOpen(false);
  };

  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang);
    userStore.setLanguage(lang);
  };

  return (
    <Box>
      <CssBaseline />
      <Main open={open} isMobile={isMobile}>
        <LoadingContainer isLoading={isLoading}>{children}</LoadingContainer>
      </Main>
      <Drawer
        sx={{
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            backgroundColor: theme.color.blue,
            color: theme.color.white,
            width: !!isMobile ? "85vw" : drawerWidth,
            border: 0,
            borderRadius: `14px 0px 0px 14px`,
          },
        }}
        variant="temporary"
        anchor={i18n.dir() === "rtl" ? "right" : "left"}
        open={open}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "37px 20px",
            gap: 14,
            flex: 1,
          }}
        >
          <DrawerHeader
            style={{
              marginBottom: `2em`,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: theme.color.white,
                  display: "flex",
                  width: "100%",
                  marginLeft: 0,
                  marginRight: 0,
                  justifyContent: "flex-start",
                  alignItems: "center",
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <img
                  src={CoralisLogo}
                  alt="logo"
                  style={{ width: 33, height: 34 }}
                />
                <img
                  src={closeMsgImg}
                  alt="close"
                  style={{
                    cursor: "pointer",
                    marginInlineStart: isMobile && "auto",
                  }}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
            </div>
          </DrawerHeader>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {userStore.userDetails.ALL_TENANT_SPACES?.length > 1 &&
              userStore.userDetails.role !== Role.Admin && (
                <DropDownMenu
                  isMobile={true}
                  key={menuKey}
                  options={userStore.userDetails.ALL_TENANT_SPACES?.map(
                    (space) => {
                      return {
                        value: space,
                        label: `${space?.SITEDES} ${space?.SPACEDES}`,
                      };
                    }
                  )}
                  onSelect={handleSelectProjectChange}
                  value={{
                    value: tenantsStore.selectedSiteSpace,
                    label: `${tenantsStore.selectedSiteSpace?.SITEDES} ${tenantsStore.selectedSiteSpace?.SPACEDES}`,
                  }}
                />
              )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {props.admin ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 10,
                }}
              >
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={
                    location.includes("projects")
                      ? buildingBoldImg
                      : buildingImg
                  }
                  title="projects"
                  selected={
                    location.includes("projects") ||
                    location.includes("tenants")
                  }
                  navigateTo={"/admin/projects"}
                  isAdmin={userStore.userDetails.role === Role.Admin}
                />
              </div>
            ) : props.bedek ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 10,
                }}
              >
                {userStore.userDetails.role === Role.Admin && (
                  <MenuItem
                    setTitle={props.setTitle}
                    setOpen={setOpen}
                    img={buildingRegImg}
                    title="projects"
                    selected={
                      location.includes("projects") ||
                      location.includes("tenants")
                    }
                    navigateTo={"/admin/projects"}
                    isAdmin={userStore.userDetails.role === Role.Admin}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={appliesImg}
                  title="applies"
                  selected={location.includes("applies")}
                  navigateTo={"/bedek/applies"}
                  isAdmin={true}
                />
                {!isMobile && <MenuItem
                  backgroundColor={theme.color.green}
                  style={{
                    flex: 1,
                    alignSelf: "end",
                    justifyContent: "end",
                  }}
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={addSquareImg}
                  title="add_apply"
                  onItemClicked={() => {
                    setShowDepratmentsMenu(!showDepratmentsMenu);
                  }}
                />}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 10,
                }}
              >
                {userStore.userDetails.role === Role.Admin && (
                  <MenuItem
                    setTitle={props.setTitle}
                    setOpen={setOpen}
                    img={buildingRegImg}
                    title="projects"
                    selected={
                      location.includes("projects") ||
                      location.includes("tenants")
                    }
                    navigateTo={"/admin/projects"}
                    isAdmin={true}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={location.includes("lobby") ? lobbyBoldImg : lobbyImg}
                  title="lobby"
                  selected={location.includes("lobby")}
                  navigateTo={"/tenant/lobby"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={location.includes("docs") ? docsBoldImg : docsImg}
                  title="docs"
                  selected={location.includes("docs")}
                  navigateTo={"/tenant/docs"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={
                    location.includes("account") ? accountBoldImg : accountImg
                  }
                  title="account"
                  selected={location.includes("account")}
                  navigateTo={"/tenant/account"}
                />
                {departments?.length > 0 && (
                  <MenuItem
                    setTitle={props.setTitle}
                    setOpen={setOpen}
                    img={
                      location.includes("applies") ? appliesBoldImg : appliesImg
                    }
                    title="applies"
                    selected={location.includes("applies")}
                    navigateTo={"/tenant/applies"}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={
                    location.includes("messages")
                      ? notificationBoldImg
                      : notificationImg
                  }
                  title="messages"
                  selected={location.includes("messages")}
                  navigateTo={"/tenant/messages"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={
                    location.includes("choosing-tenants")
                      ? appliesBoldImg
                      : appliesImg
                  }
                  title="tenant_changes"
                  selected={location.includes("choosing-tenants")}
                  navigateTo={"/tenant/choosing-tenants"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  setOpen={setOpen}
                  img={
                    location.includes("contacts")
                      ? contactsBoldImg
                      : contactsImg
                  }
                  title="contacts"
                  selected={location.includes("contacts")}
                  navigateTo={"/tenant/contacts"}
                />
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "end",
              justifyContent: "space-between",
              marginBottom: "auto",
              flex: 1,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                gap: 14,
              }}
            >
              <CircleDiv
                style={{ border: `1px solid ${theme.color.primary}`, }}
                backgroundColor={userStore.language === "he" ? theme.color.primary : theme.color.white}
                onClick={() => changeLanguageHandler("he")}
              >
                <Text.H4
                  color={userStore.language === "he" ? theme.color.white : theme.color.primary}
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize"
                  }}
                >
                  {t("login:he")}
                </Text.H4>
              </CircleDiv>
              <CircleDiv
                style={{ border: `1px solid ${theme.color.primary}` }}
                backgroundColor={userStore.language === "en" ? theme.color.primary : theme.color.white}
                onClick={() => changeLanguageHandler("en")}
              >
                <Text.H4
                  color={userStore.language === "en" ? theme.color.white : theme.color.primary}
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize"
                  }}
                >
                  {t("login:en")}
                </Text.H4>
              </CircleDiv>
            </div>
            <div
              onClick={() => {
                handlelLogout();
              }}
            >
              <img
                src={logoutImg}
                alt="logout"
              />
            </div>
          </div>
          <Line />
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}>
            <Text.SR color={theme.color.gray90}>{t('powered_by_coralis')}</Text.SR>
            <Text.SMR color={theme.color.gray90}>{t('all_right_reseverd')} </Text.SMR>
          </div>
        </div>
      </Drawer>
    </Box>
  );
};

export default inject("userStore", "tenantsStore")(observer(MobileDrawer));
